import { graphql } from '@/generated/gql';

export const INTAKE_EXTENDED_LINE_ITEMS_CHECK_QUERY = graphql(`
  query IntakeExtendedLineItemsCheck($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id

        # Extended line item checks
        extendedLineItemChecks {
          id
          chatSessionId
          position
          title
          description
          pricePerUnit
          quantity
          earlyDeliveryAt
          lateDeliveryAt
          checkResults {
            catalogueItems {
              currency
              deliveryTime
              description
              id
              inStock
              manufacturer
              name
              previewImage
              price
              punchoutUrl
              shippingCosts
            }
            contractItems {
              createdAtTimestamp
              id
              contract {
                id
                currency
                plannedValueFloat
                supplierId
              }
              plannedQuantityFloat
              pricePerUnitFloat
              title
            }
          }
          commodityGroupId
          unitId
        }
      }
    }
  }
`);
